import { render, staticRenderFns } from "./ReviewCommunication.vue?vue&type=template&id=b564bee6"
import script from "./ReviewCommunication.vue?vue&type=script&lang=js"
export * from "./ReviewCommunication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports